import { render } from "./ProjectActivity.vue?vue&type=template&id=6c6eaa24&scoped=true"
const script = {}

import "./ProjectActivity.vue?vue&type=style&index=0&id=6c6eaa24&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6eaa24"]])

export default __exports__